import { NewWizardSplitTestTemporaryId } from '../constants';
import SplitTestSettingsPage from './settings';
import SplitTestSummaryPage from './summary';
import SplitTestVariantChoicePage from './variantPage';

interface WizardPage {
  label: string;
  route: string;
}

const wizardPages: WizardPage[] = [
  { label: 'Settings', route: '/settings' },
  { label: 'Variant Choice', route: '/variant-choice' },
  { label: 'Summary', route: '/summary' },
];

const getForwardSlashStrippedRoute = (route: string): string => route.replace(/^\//, '');

const getPageIndex = (currentRoute: string): number => {
  const determinedIndex = wizardPages.findIndex(page => currentRoute === getForwardSlashStrippedRoute(page.route));
  return determinedIndex > -1 && determinedIndex;
};

const getRelativePageRoute = (step: number): string => {
  if (step < 0 || step >= wizardPages.length) {
    throw new Error(`Must be a step value between 0 and ${wizardPages.length - 1}`);
  }

  return getForwardSlashStrippedRoute(wizardPages[step].route);
};

export const createUrl = (siteId: string, splitTestId: string, page: string): string =>
  `/sites/${siteId}/campaigns/split_tests/${
    splitTestId === NewWizardSplitTestTemporaryId ? 'create' : splitTestId
  }/${page}`;

export {
  getPageIndex,
  getRelativePageRoute,
  SplitTestSettingsPage,
  SplitTestSummaryPage,
  SplitTestVariantChoicePage,
  wizardPages,
};
